var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.92215 13C7.51574 13.4414 7.51571 13.4414 7.51566 13.4413L7.51549 13.4412L7.51489 13.4406L7.51263 13.4385L7.50395 13.4305L7.47049 13.3996C7.44123 13.3725 7.39832 13.3327 7.34335 13.2815C7.23341 13.1791 7.07518 13.0311 6.88134 12.8479C6.49381 12.4817 5.96327 11.9745 5.39152 11.4104C4.26073 10.295 2.92691 8.91696 2.24415 7.97403C0.768709 5.93636 1.20235 2.76559 3.79847 1.68998C5.08723 1.15602 6.16607 1.4229 6.96507 1.97463C7.36929 2.25376 7.69674 2.60077 7.95136 2.93986C8.26046 2.58518 8.66007 2.23069 9.13088 1.95202C10.0127 1.4301 11.1854 1.15421 12.4785 1.68998C13.7899 2.23333 14.4478 3.33719 14.5761 4.5331C14.7018 5.70525 14.3261 6.97148 13.6001 7.97403C12.9174 8.91696 11.5836 10.295 10.4528 11.4104C9.88103 11.9745 9.35048 12.4817 8.96295 12.8479C8.76912 13.0311 8.61088 13.1791 8.50094 13.2815C8.44597 13.3327 8.40306 13.3725 8.3738 13.3996L8.34035 13.4305L8.33167 13.4385L8.3294 13.4406L8.3288 13.4412L8.32863 13.4413C8.32858 13.4414 8.32855 13.4414 7.92215 13ZM7.92215 13L7.51574 13.4414C7.74542 13.6529 8.09888 13.6529 8.32855 13.4414L7.92215 13Z",
    stroke: "black",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.e09f0688484356825cc52c8960c213dc.svg";
export { ForwardRef as ReactComponent };